// import axios from "axios"
import { propertyAPI } from "../../axios";

export const actions = {

    //Inspection IAR
    GetPropertyIar(context, data){
        return propertyAPI.get(`Property/Submitted/IAR/${data.campusId}/${data.cycle}`);
    },
    PostPropertyIar(context, data){
        return propertyAPI.put(`Property/IAR/Item/${data}`);
    },

}